import { ArrowRight, CalendarCheck } from "lucide-react";
import { useLang } from "@/i18n";

export default function Hero() {
  const { t } = useLang();
  return (
    <section id="accueil" className="relative flex min-h-screen flex-col overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-[#FCFBF8] via-[#FAF8F4] to-[#F0ECE4]" />
      <div className="pointer-events-none absolute -right-24 top-16 hidden select-none font-display text-[24rem] font-semibold leading-none text-[#A87C4F]/[0.07] lg:block">
        EBS
      </div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-1 flex-col justify-center px-5 pb-24 pt-40 sm:px-8">
        <p className="eyebrow reveal reveal-1" data-testid="hero-eyebrow">
          {t.hero.eyebrow}
        </p>

        <h1
          className="reveal reveal-2 mt-6 max-w-4xl font-display text-4xl font-semibold leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl"
          data-testid="hero-title"
        >
          {t.hero.title1}
          <span className="gold-gradient-text italic">{t.hero.titleAccent}</span>
        </h1>

        <p className="reveal reveal-3 mt-7 max-w-2xl text-base leading-relaxed text-[#5F5647] sm:text-lg">
          {t.hero.sub}
        </p>

        <div className="reveal reveal-4 mt-10 flex flex-wrap items-center gap-4">
          <a
            href="#rendez-vous"
            data-testid="hero-cta-audit-button"
            className="btn-gold inline-flex items-center gap-2 rounded-sm px-8 py-4 text-sm font-semibold uppercase tracking-[0.12em]"
          >
            <CalendarCheck size={17} />
            {t.hero.cta1}
          </a>
          <a
            href="#services"
            data-testid="hero-cta-contact-button"
            className="btn-outline-gold inline-flex items-center gap-2 rounded-sm px-8 py-4 text-sm font-semibold uppercase tracking-[0.12em]"
          >
            {t.hero.cta2}
            <ArrowRight size={16} />
          </a>
        </div>

        <div className="reveal reveal-5 mt-16 grid max-w-4xl grid-cols-2 gap-3 sm:grid-cols-4">
          {t.hero.kpis.map((kpi, i) => (
            <div
              key={kpi.label}
              className="card-lux animate-float-slow rounded-md px-5 py-5 backdrop-blur-md"
              style={{ animationDelay: `${i * 0.7}s` }}
              data-testid={`hero-kpi-${i}`}
            >
              <p className={`font-display text-3xl font-semibold ${i % 2 ? "text-[#C09A6B]" : "text-[#6E4E2E]"}`}>{kpi.value}</p>
              <p className="mt-2 text-[11px] uppercase tracking-[0.14em] text-[#948678]">
                {kpi.label}
              </p>
            </div>
          ))}
        </div>
        <p className="mt-4 text-[10px] tracking-wide text-[#948678]/80">
          {t.hero.note}
        </p>
      </div>

      <div className="relative border-t border-[#A87C4F]/20 bg-[#FAF8F4]/85 py-5 backdrop-blur-md">
        <div className="flex w-max animate-marquee gap-10 whitespace-nowrap">
          {[...t.hero.ribbon, ...t.hero.ribbon].map((item, i) => (
            <span
              key={i}
              className="flex items-center gap-10 text-[12px] uppercase tracking-[0.3em] text-[#948678]"
            >
              {item}
              <span className="text-[#A87C4F]">◆</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
